import { useEffect, useState } from "react";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001";

function getToken() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}

function montarUrlLogo(logoEmpresa) {
  if (!logoEmpresa) return "";

  const logo = String(logoEmpresa).trim();

  if (!logo) return "";

  if (logo.startsWith("http://") || logo.startsWith("https://")) {
    return logo;
  }

  if (logo.startsWith("/")) {
    return `${API_URL}${logo}`;
  }

  return `${API_URL}/${logo}`;
}

export default function Perfil() {
  const [dados, setDados] = useState(null);
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [telefone, setTelefone] = useState("");
  const [logo, setLogo] = useState(null);
  const [previewLogo, setPreviewLogo] = useState("");

  const [loading, setLoading] = useState(false);
  const [enviandoLogo, setEnviandoLogo] = useState(false);
  const [alterandoSenha, setAlterandoSenha] = useState(false);

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [mostrarSenhaAtual, setMostrarSenhaAtual] = useState(false);
  const [mostrarNovaSenha, setMostrarNovaSenha] = useState(false);
  const [mostrarConfirmarSenha, setMostrarConfirmarSenha] = useState(false);

  const token = getToken();

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!logo) {
      setPreviewLogo("");
      return;
    }

    const url = URL.createObjectURL(logo);
    setPreviewLogo(url);

    return () => URL.revokeObjectURL(url);
  }, [logo]);

  async function carregar() {
    try {
      const res = await fetch(`${API_URL}/configuracoes`, {
        headers: { Authorization: token },
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Erro ao carregar perfil");
        return;
      }

      setDados(data);
      setNomeEmpresa(data.nomeEmpresa || "");
      setTelefone(data.telefone || "");
    } catch (err) {
      alert("Erro ao carregar perfil");
    }
  }

  async function salvar() {
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/configuracoes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          nomeEmpresa,
          telefone,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Perfil atualizado com sucesso ✅");
        carregar();
      } else {
        alert(data.error || "Erro ao salvar");
      }
    } catch (err) {
      alert("Erro ao conectar com servidor");
    }

    setLoading(false);
  }

  async function enviarLogo() {
    if (!logo) {
      alert("Selecione uma imagem");
      return;
    }

    const formData = new FormData();
    formData.append("logo", logo);

    setEnviandoLogo(true);

    try {
      const res = await fetch(`${API_URL}/upload-logo`, {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        const logoAtualizada =
          data.logoEmpresa || data.url || data.logoUrl || dados.logoEmpresa || "";

        setDados((atual) => ({
          ...(atual || {}),
          logoEmpresa: logoAtualizada,
        }));

        setLogo(null);
        await carregar();

        alert("Logo atualizada com sucesso 🎉");
      } else {
        alert(data.error || data.erro || "Erro ao enviar logo");
      }
    } catch (err) {
      alert("Erro ao enviar logo");
    }

    setEnviandoLogo(false);
  }

  async function alterarSenha(e) {
    e.preventDefault();

    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      alert("Preencha todos os campos de senha.");
      return;
    }

    if (novaSenha.length < 6) {
      alert("A nova senha precisa ter pelo menos 6 caracteres.");
      return;
    }

    if (novaSenha !== confirmarSenha) {
      alert("A confirmação da senha não confere.");
      return;
    }

    if (senhaAtual === novaSenha) {
      alert("A nova senha precisa ser diferente da senha atual.");
      return;
    }

    setAlterandoSenha(true);

    try {
      const res = await fetch(`${API_URL}/alterar-senha`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          senhaAtual,
          novaSenha,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Erro ao alterar senha");
        return;
      }

      setSenhaAtual("");
      setNovaSenha("");
      setConfirmarSenha("");

      alert(data.message || "Senha alterada com sucesso ✅");
    } catch (err) {
      alert("Erro ao conectar com servidor");
    } finally {
      setAlterandoSenha(false);
    }
  }

  function nomeCargo(role) {
    const nomes = {
      master: "Master",
      gestor: "Gestor",
      franquia: "Franquia",
      colaborador: "Colaborador",
    };

    return nomes[role] || role;
  }

  function nomePlano(plano) {
    const nomes = {
      beta_master: "Beta Master",
      beta_gestor: "Beta Gestor",
      beta_franquia: "Beta Franquia",
      beta_colaborador: "Beta Colaborador",
    };

    return nomes[plano] || plano;
  }

  if (!dados) {
    return <p>Carregando...</p>;
  }

  const logoParaMostrar = previewLogo || montarUrlLogo(dados.logoEmpresa);

  return (
    <>
      <style>{css}</style>

      <div className="perfilPage">
        <div className="perfilHeader">
          <div>
            <h1>👤 Meu Perfil</h1>
            <p>Gerencie seus dados, logo da empresa, plano e segurança.</p>
          </div>
        </div>

        <div className="box">
          <h2>Informações</h2>

          <div className="grid">
            <div>
              <label>Nome da empresa</label>
              <input
                placeholder="Nome da empresa"
                value={nomeEmpresa}
                onChange={(e) => setNomeEmpresa(e.target.value)}
              />
            </div>

            <div>
              <label>Telefone</label>
              <input
                placeholder="Telefone"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
              />
            </div>

            <div>
              <label>E-mail</label>
              <input
                className="inputBloqueado"
                value={dados.email || ""}
                disabled
              />
            </div>

            <div>
              <label>Cargo</label>
              <input
                className="inputBloqueado"
                value={nomeCargo(dados.role)}
                disabled
              />
            </div>
          </div>

          <button className="btnPrimario" onClick={salvar} disabled={loading}>
            {loading ? "Salvando..." : "Salvar"}
          </button>
        </div>

        <div className="box">
          <h2>Logo da empresa</h2>

          <div className="logoArea">
            {logoParaMostrar ? (
              <img
                src={logoParaMostrar}
                alt="Logo da empresa"
                className="logoPreview"
                onError={(e) => {
                  console.log("Erro ao carregar logo:", e.currentTarget.src);
                  e.currentTarget.style.display = "none";
                }}
              />
            ) : (
              <div className="logoVazio">Sem logo</div>
            )}

            <div className="uploadArea">
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp"
                onChange={(e) => setLogo(e.target.files?.[0] || null)}
              />

              <button
                className="btnPrimario"
                onClick={enviarLogo}
                disabled={enviandoLogo}
              >
                {enviandoLogo ? "Enviando..." : "Enviar logo"}
              </button>

              <p className="textoAjuda">
                Formatos recomendados: PNG ou JPG. Use uma imagem quadrada para
                melhor resultado.
              </p>
            </div>
          </div>
        </div>

        <div className="box">
          <h2>Segurança</h2>

          <p className="descricao">
            Altere sua senha de acesso sempre que precisar. Para sua segurança,
            informe a senha atual antes de criar uma nova senha.
          </p>

          <form onSubmit={alterarSenha}>
            <div className="gridSenha">
              <div>
                <label>Senha atual</label>

                <div className="senhaBox">
                  <input
                    type={mostrarSenhaAtual ? "text" : "password"}
                    placeholder="Digite sua senha atual"
                    value={senhaAtual}
                    onChange={(e) => setSenhaAtual(e.target.value)}
                  />

                  <button
                    type="button"
                    className="btnOlho"
                    onClick={() => setMostrarSenhaAtual(!mostrarSenhaAtual)}
                  >
                    {mostrarSenhaAtual ? "Ocultar" : "Mostrar"}
                  </button>
                </div>
              </div>

              <div>
                <label>Nova senha</label>

                <div className="senhaBox">
                  <input
                    type={mostrarNovaSenha ? "text" : "password"}
                    placeholder="Nova senha"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                  />

                  <button
                    type="button"
                    className="btnOlho"
                    onClick={() => setMostrarNovaSenha(!mostrarNovaSenha)}
                  >
                    {mostrarNovaSenha ? "Ocultar" : "Mostrar"}
                  </button>
                </div>
              </div>

              <div>
                <label>Confirmar nova senha</label>

                <div className="senhaBox">
                  <input
                    type={mostrarConfirmarSenha ? "text" : "password"}
                    placeholder="Confirme a nova senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                  />

                  <button
                    type="button"
                    className="btnOlho"
                    onClick={() =>
                      setMostrarConfirmarSenha(!mostrarConfirmarSenha)
                    }
                  >
                    {mostrarConfirmarSenha ? "Ocultar" : "Mostrar"}
                  </button>
                </div>
              </div>
            </div>

            <button
              className="btnSeguranca"
              type="submit"
              disabled={alterandoSenha}
            >
              {alterandoSenha ? "Alterando..." : "Alterar senha"}
            </button>
          </form>
        </div>

        <div className="box">
          <h2>Plano</h2>

          <div className="planoCard">
            <div>
              <strong>{nomePlano(dados.plano)}</strong>

              <p className="statusPlano">
                {dados.assinatura?.status === "beta"
                  ? "Versão Beta (gratuito)"
                  : dados.assinatura?.status}
              </p>

              <p className="valorPlano">
                Valor atual:{" "}
                {Number(dados.assinatura?.valor || 0).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const css = `
.perfilPage {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.perfilHeader {
  margin-bottom: 22px;
}

.perfilHeader h1 {
  margin: 0;
  color: #020617;
  font-size: clamp(30px, 5vw, 42px);
  font-weight: 900;
}

.perfilHeader p {
  color: #64748b;
  margin: 8px 0 0;
}

.box {
  background: #f8fafc;
  padding: 26px;
  border-radius: 20px;
  margin-bottom: 24px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  border: 1px solid #eef2f7;
}

.box h2 {
  margin: 0 0 18px;
  color: #020617;
  font-size: 25px;
  font-weight: 900;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.gridSenha {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

label {
  display: block;
  font-weight: 800;
  margin-bottom: 7px;
  color: #334155;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 13px 14px;
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  box-sizing: border-box;
  outline: none;
  font-size: 15px;
  background: white;
}

input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.inputBloqueado {
  background: #e5e7eb;
  cursor: not-allowed;
  color: #475569;
}

.btnPrimario,
.btnSeguranca {
  padding: 13px 20px;
  border-radius: 13px;
  border: none;
  color: white;
  font-weight: 900;
  cursor: pointer;
  margin-top: 12px;
}

.btnPrimario {
  background: linear-gradient(135deg, #0f172a, #020617);
}

.btnSeguranca {
  background: linear-gradient(135deg, #2563eb, #0284c7);
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
}

.btnPrimario:disabled,
.btnSeguranca:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.logoArea {
  display: flex;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}

.logoPreview,
.logoVazio {
  width: 104px;
  height: 104px;
  border-radius: 50%;
  border: 3px solid #e5e7eb;
  background: white;
  flex-shrink: 0;
}

.logoPreview {
  object-fit: cover;
}

.logoVazio {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 13px;
}

.uploadArea {
  min-width: 260px;
}

.textoAjuda,
.descricao,
.valorPlano {
  color: #64748b;
  font-size: 14px;
  margin: 8px 0 0;
}

.senhaBox {
  display: flex;
  align-items: center;
  border: 1px solid #cbd5e1;
  background: white;
  border-radius: 12px;
  overflow: hidden;
}

.senhaBox:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.senhaBox input {
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  min-width: 0;
}

.btnOlho {
  border: none;
  background: transparent;
  color: #0284c7;
  font-weight: 900;
  padding: 0 14px;
  cursor: pointer;
  white-space: nowrap;
}

.planoCard {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 18px;
}

.planoCard strong {
  color: #020617;
  font-size: 18px;
}

.statusPlano {
  color: #22c55e;
  font-weight: 900;
  margin: 8px 0 0;
}

@media (max-width: 900px) {
  .grid,
  .gridSenha {
    grid-template-columns: 1fr;
  }

  .box {
    padding: 20px;
  }

  .btnPrimario,
  .btnSeguranca {
    width: 100%;
    min-height: 50px;
  }

  .uploadArea {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 420px) {
  .box {
    padding: 16px;
  }

  .senhaBox {
    align-items: stretch;
  }

  .btnOlho {
    padding: 0 10px;
    font-size: 12px;
  }
}
`;
